import React, { Component, PropTypes } from 'react';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { RaisedButton } from 'material-ui';
import { push as routerPush } from 'react-router-redux';
import workspacePlaceholderImage from '../../../www/images/workspace_placeholder.svg';
import { getConnections } from './store/actions';
import { openModal as openMassDialog } from '../massmessaging/store/actions';

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& div': {
      textAlign: 'center',
    },
  },
  startConversation: {
    marginTop: '10px',
    '& > div': {
      margin: '20px',
    },
  },
  title: {
    fontSize: '16px',
    color: 'rgba(0,0,0,0.54)',
  },
  placeHolderImage: {
    minHeight: '375px',
  },
};
class Placeholder extends Component {
  componentDidMount() {
    if (!this.timer) this.timer = setInterval(this.timedUpdate, 4e3);
  }
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  timer = null
  timedUpdate = () => {
    if (!localStorage.stopAutoReload && !this.props.connectionsFetching) this.props.getConnections();
  }
  render() {
    const { classes } = this.props;
    return (
        <div className={`${classes.container} l-app-content`}>
          <div>
            <div>
            <img src={workspacePlaceholderImage} className={classes.placeHolderImage}/>
            </div>
            <div className={classes.title}>
              Welcome to the Messaging Workspace<br/>
              Here, you can chat with your partners, or respond to contract-related messages.
            </div>
            <div className={classes.startConversation}>
              <RaisedButton
                label="Compose a new Message"
                secondary
                buttonStyle={{ zIndex: 'inherited' }}
                onTouchTap={() => { this.props.openMassDialog(); }}
              />
            </div>
          </div>
        </div>
      );
  }
}

Placeholder.propTypes = {
  connectionsFetching: PropTypes.bool,
  classes: PropTypes.object,
  getConnections: PropTypes.func,
  routerPush: PropTypes.func,
  openMassDialog: PropTypes.func,
};

const select = (state) => ({
  connectionsFetching: state.workspace.connectionsFetching,
});

export default connect(select, { routerPush, getConnections, openMassDialog })(injectSheet(styles)(Placeholder));



// WEBPACK FOOTER //
// ./src/app/components/workspace/placeholder.jsx